import { useRef } from 'react';

/**
 * Hold constant value for the full lifetime of the component.
 * @param {*} v - const value
 * @return {*}
 */
export const useConst = (v) => useRef(v).current;
